import RealtimeRevenueFilter from '@/pages/dashboard/filterPageComponents/realtime/realtimeRevenueFilter';

export const REALTIME_REVENUE_FILTER_KEY = 'realtime_revenue';

export const realtimeRevenueFilterInfo = {
  key: REALTIME_REVENUE_FILTER_KEY,
  path: 'realtime/revenue',
  Filter: RealtimeRevenueFilter
}

export default {
  [REALTIME_REVENUE_FILTER_KEY]: realtimeRevenueFilterInfo
}
